export type AppsFlyerClient = Readonly<{
  initSdk: (
    settings: AppsFlyerSettings,
    success?: (result: string) => void,
    failure?: (error: string) => void,
  ) => void;

  onInstallConversionData: (callback: (data: Record<string, unknown>) => void) => () => void;

  setCustomerUserId: (userId: string | null, callback?: (result: string) => void) => void;

  logEvent: (
    eventName: string,
    eventValues?: Record<string, unknown>,
    success?: (result: string) => void,
    failure?: (error: string) => void,
  ) => void;
}>;

export type AppsFlyerResult = Readonly<{
  initializeAppsFlyer: () => Promise<void>;
  setCustomerUserId: (userId: string | null) => void;
  logCompleteRegistrationEvent: () => void;
  logLoginEvent: () => void;
  logContentViewEvent: (payload: AppsFlyerContentViewPayload) => void;
  logAddToCartEvent: (payload: AppsFlyerAddToCartPayload) => void;
  logInitiatedCheckoutEvent: (payload: AppsFlyerInitiatedCheckoutPayload) => void;
  logPurchaseEvent: (payload: AppsFlyerPurchasePayload) => void;
}>;

/**
 * @see {@link https://evgen.appsflyer.com/?vertical=ecommerce}
 */
export type AppsFlyerContentViewPayload = Readonly<{
  price: number;
  contentId: string;
  contentType: string;
}>;

/**
 * @see {@link https://evgen.appsflyer.com/?vertical=ecommerce}
 */
export type AppsFlyerAddToCartPayload = Readonly<{
  price: number;
  contentId: string;
  contentType: string;
  quantity: number;
}>;

/**
 * @see {@link https://evgen.appsflyer.com/?vertical=ecommerce}
 */
export type AppsFlyerInitiatedCheckoutPayload = Readonly<{
  price: number;
  productIds: string;
  orderType: string;
  quantity: number;
}>;

export type AppsFlyerPurchasePayload = Readonly<{
  orderId: string;
  orderValue: number;
  orderType: string;
  bagCount: number;
  productIds: string;
}>;

type AppsFlyerSettings = Readonly<{
  devKey: string;
  isDebug: boolean;
  appId: string;
  onInstallConversionDataListener?: boolean;
  onDeepLinkListener?: boolean;
  timeToWaitForATTUserAuthorization: number;
}>;
